import ModalBase from "connectui/component/modal/ModalBase";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import React, {useRef, useState} from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import OutlinedInputBase from "connectui/component/input/text/OutlinedInputBase";
import ButtonText from "connectui/component/input/button/ButtonText";
import SvgIcon from "connectui/component/display/SvgIcon";
import {buildStyles} from "connectui/component/buildStyles";
import OutlinedButtonBase from "connectui/component/input/button/base/OutlinedButtonBase";
import DatePicker from "connectui/component/input/calendar/DatePicker";
import TimeInput from "connectui/component/input/text/type/TimeInput";
import ICONS from "connectui/icons/iconMap";
import RoundIcon from "connectui/component/display/RoundIcon";
import {useTranslation} from "react-i18next";

const useStyles = (theme) =>
  buildStyles({
    buttonIcon: {
      width: "20px",
      height: "20px",
      marginRight: theme.spacing(2),
    },
  });

export default function SnoozeModal({isOpen, onClose}) {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("00:00");
  const buttonWrapperRef = useRef(null);
  const {t} = useTranslation();

  const handleConfirm = () => {
    if (selectedDate && selectedTime) {
      const [hours, minutes] = selectedTime.split(":").map(Number);
      const combinedDate = new Date(selectedDate);
      combinedDate.setHours(hours, minutes, 0, 0);
      const timestamp = combinedDate.getTime();
      onClose(timestamp);
    } else {
      onClose(null);
    }
  };

  return (
    <ModalBase isOpen={isOpen} onClose={onClose}>
      <FlexContainer
        flexDirection="column"
        alignItems="flex-start"
        gap={theme.spacing(5)}
        sx={{padding: theme.spacing(2), maxWidth: "450px"}}
      >
        <RoundIcon iconComponent={"send-scheduled"} baseColor={"primary"} />
        <Text
          variant="textLG"
          weight="semibold"
          sx={{marginTop: theme.spacing(1)}}
        >
          {t("inbox.conversations.snooze-modal.title")}
        </Text>
        <Text variant="textSM" color="gray600">
          {t("inbox.conversations.snooze-modal.subtitle")}
        </Text>
        <FlexContainer
          gap={theme.spacing(3)}
          justifyContent={"space-between"}
          sx={{flex: 1, width: "100%", flexFlow: "wrap"}}
        >
          <FlexContainer flexDirection={"column"} gap={theme.spacing(1)}>
            <Text variant="textSM" color="gray600">
              {t("inbox.conversations.snooze-modal.time.label")}
            </Text>
            <TimeInput
              inputBase={OutlinedInputBase}
              sx={{width: "200px", height: "40px"}}
              startIcon={
                <SvgIcon
                  component={ICONS["clock"]}
                  className={classes.buttonIcon}
                />
              }
              onChange={(e) => {
                console.log("TIME CHANGED", e);
                setSelectedTime(e);
              }}
            />
          </FlexContainer>
          <FlexContainer
            flexDirection={"column"}
            gap={theme.spacing(1)}
            ref={buttonWrapperRef}
          >
            <Text variant="textSM" color="gray600">
              {t("inbox.conversations.snooze-modal.date.label")}
            </Text>
            <DatePicker
              open={datePickerOpen}
              setOpen={setDatePickerOpen}
              initialDate={new Date()}
              selectedDate={selectedDate}
              onDateChange={setSelectedDate}
              sx={{width: "200px", height: "40px"}}
            />
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          gap={theme.spacing(3)}
          justifyContent={"space-between"}
          sx={{flex: 1, width: "100%"}}
        >
          <ButtonText
            buttonBase={OutlinedButtonBase}
            label={t("inbox.conversations.snooze-modal.buttons.cancel")}
            sx={{width: "100%", flex: 1}}
            onClick={() => onClose(null)}
          />
          <ButtonText
            label={t("inbox.conversations.snooze-modal.buttons.confirm")}
            color={theme.colors.gray100}
            sx={{width: "100%", flex: 1}}
            onClick={handleConfirm}
          />
        </FlexContainer>
      </FlexContainer>
    </ModalBase>
  );
}
